<script lang="ts" setup>
import { useWorkshop } from '~/composables/cms/workshop'
import TeamCarousel from '~/components/workshop/team-carousel.vue'
import Swoosh from '~/assets/swoosh.svg?component'

const { workshop } = useWorkshop()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 pb-16 pt-32 text-center md:pb-16 lg:pb-16">
    <Heading as="h2" class="w-full lg:w-1/2" size="large">{{ workshop.team?.title }}</Heading>
    <div class="flex w-full flex-col items-center justify-center pb-16 lg:w-1/2">
      <RichText v-if="workshop.team?.description" :raw="workshop.team?.description" />
      <Swoosh class="mt-4" />
    </div>

    <TeamCarousel :first="false" :items="workshop.team?.image_grid || []" />
    <TeamCarousel :first="true" :items="workshop.team?.second_image_grid || []" />
  </Container>
</template>
